import React, { useEffect, useRef, useState } from 'react';

const AnimateIn = ({ children, direction = 'left', className = '', as: Tag = 'div', delay = 0 }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let timeoutId;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          timeoutId = setTimeout(() => setVisible(true), delay);
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(el);
    return () => {
      observer.disconnect();
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [delay]);

  const animClass =
    direction === 'right'
      ? 'animate-fade-in-right'
      : direction === 'up'
        ? 'animate-fade-in-up'
        : 'animate-fade-in-left';
  const visibleClass = visible ? 'animate-visible' : '';

  return (
    <Tag ref={ref} className={`${animClass} ${visibleClass} ${className}`.trim()}>
      {children}
    </Tag>
  );
};

export default AnimateIn;
